<template>
  <el-row
    ><el-col :lg="3">
      <el-button
        type="primary"
        size="medium"
        @click="goBack"
        class="backButton"
      >
        Back
      </el-button></el-col
    ><el-col :lg="18"
      ><div
        v-if="erroMessage && !this.showAllApps"
        class="integration-box error-box"
      >
        <el-card>
          <el-alert
            title="Error"
            type="error"
            :description="erroMessage"
            show-icon
            effect="light"
            class="custom-alert"
          />
        </el-card>
      </div>
      <el-container class="integratiostyles" v-if="showAllApps">
        <el-main>
          <el-card class="integration-box">
            <div>
              <el-text
                tag="b"
                size="large"
                style="
                  font-size: 21px;
                  bottom: 12px;
                  position: relative;
                  color: #351915;
                  font-weight: 700;
                "
                >Select an Integration</el-text
              >
              <br />
              <el-text
                tag="p"
                size="small"
                style="font-size: 13px; color: #424a52"
              >
                Your authorization credentials will be required to connect these
                integrations.
              </el-text>
            </div>
            <div class="border">
              <el-input
                class="search-button"
                v-model="searchIntegrationApps"
                placeholder="Search for an integration"
                size="small"
                clearable
              >
                <template #prefix>
                  <el-icon><Search /></el-icon>
                </template>
              </el-input>
              <div class="test">
                <el-row class="all-integrationapps" justify="start">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="8"
                    :lg="8"
                    v-for="app in filteredIntegrationApps"
                    :key="app._id"
                  >
                    <el-card
                      class="app-card-container"
                      :class="{ selected: selectedAppId === app._id }"
                      shadow="hover"
                      @click="selectApp(app)"
                    >
                      <div class="app-details">
                        <div class="image_style">
                          <img class="app-logo" :src="iconsUrl + app.logo" />
                        </div>
                        <span class="app-name">{{ app.label }}</span>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-main>
      </el-container></el-col
    ></el-row
  >
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store/index";
import { Search } from "@element-plus/icons-vue";
export default {
  data() {
    return {
      searchIntegrationApps: "",
      selectedAppId: null,
      selectedApp: null,
      oauthDialogVisible: false,
      nonOauthDialogVisible: false,
      showAllApps: true,
      erroMessage: "",
      activateBack: false,
    };
  },
  computed: {
    ...mapGetters("globalApis", ["getAllIntegrations"]),
    filteredIntegrationApps() {
      const apps = this.getAllIntegrations?.data || [];
      if (!this.searchIntegrationApps) return apps;
      const query = this.searchIntegrationApps.toLowerCase();
      return apps.filter((app) =>
        (app.label || "").toLowerCase().includes(query)
      );
    },
    iconsUrl() {
      return process.env.VUE_APP_ICONS_BASE_URL;
    },
  },
  components: {
    Search,
  },
  mounted() {
    this.checkUrl();
  },
  methods: {
    goBack() {
      window.open(
        `${this.$route.query.redirect_url}?state=${this.$route.query.state}`,
        "_self"
      );
    },
    async checkUrl() {
      const requiredParams = ["state", "redirect_url"];
      let urlParams = this.$route.query;
      const missingParams = requiredParams.find((param) => !urlParams[param]);
      if (missingParams) {
        this.erroMessage = `Missing required parameter(s): ${missingParams}`;
        this.showAllApps = false;
        return false;
      }
      if (urlParams["from"]) {
        this.activateBack = true;
      }
      this.showAllApps = true;
      await this.fetchIntegrationApps();
    },
    async fetchIntegrationApps() {
      await store.dispatch("globalApis/getAllIntegrations");
    },
    selectApp(app) {
      this.showAllApps = false;
      this.selectedAppId = app._id;
      this.selectedApp = app;
      this.$router.push({
        path: "/integrations",
        query: {
          ...this.$route.query,
          app: app.key,
        },
      });
    },
    handleBackFromOauth() {
      this.showAllApps = true;
      this.selectedApp = null;
      this.selectedAppId = null;
      this.oauthDialogVisible = false;
    },
    handleBackFromNonOauth() {
      this.showAllApps = true;
      this.selectedApp = null;
      this.selectedAppId = null;
      this.nonOauthDialogVisible = false;
    },
  },
};
</script>
<style scoped>
.error-box {
  padding: 20px;
  width: 792px;
  margin: 0 auto;
  background-color: #fff8f8;
  border: 1px solid #f5c6cb;
}

.custom-alert {
  font-size: 14px;
  color: #a94442;
}

.integratiostyles {
  width: 100%;
  height: auto;
  background-color: #fafafa;
  padding: 30px;
  overflow: hidden;
}

.integration-box {
  padding: 20px;
  width: 792px;
  height: 619px;
  margin: 0 auto;
  background-color: #fafafa;
  border: 1px solid #ddd;
}

.all-integrationapps {
  margin-top: 20px;
}

.search-button {
  width: 408px;
  margin: 20px 0;
  font-size: 12px;
  color: #bdbdbd;
  border-radius: 3px;
  height: 34px;
}
.border {
  background: #fafafa;
  border: 1px solid #ddd;
  max-width: 900px;
  margin: 24px -25px -20px;
  padding: 3px 15px 1px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 67vh;
}
.app-card-container {
  display: flex;
  align-items: center;
  border: 2px solid #ddd;
  border-radius: 4px;
  padding: 12px 16px;
  background-color: #fafafa;
  cursor: pointer;
  flex: 1 1 200px;
  max-width: 234px;
  transition: border-color 0.7s, box-shadow 0.7s;
  height: 45px;
  position: relative;
  bottom: 23px;
}
.app-card-container:hover {
  border-color: #355cf6;
}
.app-card-container.selected {
  border-color: #355cf6;
  box-shadow: 0 0 8px #355cf6(24, 144, 255, 0.2);
}

.image_style {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  margin-right: 12px;
  border: none !important;
}

.app-details {
  display: flex;
  align-items: center;
}
.app-logo {
  width: 19px;
  height: 19px;
  object-fit: contain;
  margin-left: -25px;
}

.app-name {
  font-weight: 400;
  color: #8d8686;
  margin: -17px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
}
.test {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>
